import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ColumnBlock, ColumnContent } from '../../layout/components';

const TextAsideBlock = props => {
  const { breakpoint, children, layoutAlign, verticalAlign, withPadding } = props;
  const numColumns = breakpoint === 'desktop' ? 1.5 : 2;
  const paddingLeft = layoutAlign === 'right' ? '6.25rem' : '3.75rem';
  const paddingTop = breakpoint === 'phone' ? 0 : (withPadding && '3.75rem');
  const alignBottom = verticalAlign === 'bottom';
  return (
    <ColumnBlock columns={numColumns} alignBottom={alignBottom}>
      <ColumnContent paddingLeft={paddingLeft} paddingTop={paddingTop}>
        {children}
      </ColumnContent>
    </ColumnBlock>
  );
};

TextAsideBlock.propTypes = {
  breakpoint: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  layoutAlign: PropTypes.oneOf(['left', 'right']),
  verticalAlign: PropTypes.oneOf(['bottom', 'top']),
  withPadding: PropTypes.bool,
};

TextAsideBlock.defaultProps = {
  layoutAlign: 'left',
  verticalAlign: 'top',
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(TextAsideBlock);



// WEBPACK FOOTER //
// ./src/modules/pages/components/TextAsideBlock.js